import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./modules/index";
import cstRoutes from './constant-routes';
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  console.log('路由', location)
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);
const router = new VueRouter({
  // mode:'history',
  routes: routes.concat(cstRoutes)
});

// router.beforeEach((to, from, next) => {
//   next();
// })

// router.afterEach((to, from) => {
// });

export default router;
